import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { setServices } from '../../redux/ui/actions';
import { RootState } from '../../redux/types';
import { MultiSelector } from '../../components/core/MultiSelector';

export const ServiceSelector = () => {
  const [serviceCodes, setServiceCodes] = useState<string[]>(useSelector((state: RootState) => state.ui.services));
  const services = useSelector((state: RootState) => state.serviceOffering.services);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setServices(serviceCodes));
  }, [dispatch, serviceCodes]);

  return (
    <MultiSelector
      disabled={services.isFetching}
      label="Services"
      placeholder={services.isFetching ? 'Loading services...' : 'Select services'}
      items={services.data?.filter((m) => m.name.indexOf('child') === -1).map((m) => ({ key: m.code, text: m.name })) || []}
      selectedKeys={serviceCodes}
      onChange={(v) => setServiceCodes(v)}
      styles={{ width: 210 }}
      testId="dd_service"
    />
  );
};
